import { render, staticRenderFns } from "./SubscriptionSettingsPayPage.vue?vue&type=template&id=33c460ca&scoped=true&"
import script from "./SubscriptionSettingsPayPage.vue?vue&type=script&lang=js&"
export * from "./SubscriptionSettingsPayPage.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionSettingsPayPage.vue?vue&type=style&index=0&id=33c460ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c460ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
